import { importScript } from './utils.js';

export default class IterableUtils {
  static install() {
    return importScript('//js.iterable.com/analytics.js');
  }

  static get instance() {
    return window._iaq;
  }

  static get isInstalled() {
    return '_iaq' in window;
  }

  static account(apiKey) {
    try {
      return IterableUtils.instance.account(apiKey);
    } catch (e) {
      console.error(e);
    }
  }

  static identify(email, data) {
    try {
      return IterableUtils.instance.identify(email, data);
    } catch (e) {
      console.error(e);
    }
  }

  static track(event, data) {
    try {
      return IterableUtils.instance.track(event, data);
    } catch (e) {
      console.error(e);
    }
  }
}
